import SanityClient from '@sanity/client';

let currentSanityInfo = null;

export const setSanityInfo = (obj) => {
  currentSanityInfo = { ...obj };
};

export const client = () => {
  if (currentSanityInfo === null || currentSanityInfo.projectId === undefined) {
    console.error(
      'ERROR: Trying to create SanityClient without valid dataset and projectId'
    );
    return null;
  }
  let sanity = new SanityClient({
    dataset: currentSanityInfo.dataset,
    projectId: currentSanityInfo.projectId,
    token: currentSanityInfo.token,
    apiVersion: '2021-08-31',
    useCdn: false,
    ignoreBrowserTokenWarning: true
  });

  return sanity;
};
